var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgClose = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", width: 14.276, height: 14.276 }, props), /* @__PURE__ */ React.createElement("path", { d: "M6.195 7.138 0 .943.943 0l6.195 6.195L13.333 0l.943.943-6.195 6.195 6.195 6.195-.943.943-6.195-6.195-6.195 6.195L0 13.333l6.195-6.195Z", fillRule: "evenodd", fill: "#FFF" }));
export { SvgClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHdpZHRoPSIxNC4yNzYiIGhlaWdodD0iMTQuMjc2Ij48cGF0aCBkPSJNNi4xOTUgNy4xMzggMCAuOTQzLjk0MyAwbDYuMTk1IDYuMTk1TDEzLjMzMyAwbC45NDMuOTQzLTYuMTk1IDYuMTk1IDYuMTk1IDYuMTk1LS45NDMuOTQzLTYuMTk1LTYuMTk1LTYuMTk1IDYuMTk1TDAgMTMuMzMzbDYuMTk1LTYuMTk1WiIgZmlsbC1ydWxlPSJldmVub2RkIiBmaWxsPSIjRkZGIi8+PC9zdmc+";
